<template>
  <div class="paintings">
    <navigation></navigation>
    <!-- Circle Preloader -->
    <h3>Works on Paper</h3>
    <div class="container">
      <div class="card-columns">
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/worksonpaper/akt1.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Akt 1</i><br />
              A4, pencil on paper
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/worksonpaper/ascher.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Zwei Bierdeckel und ein Aschenbecher</i><br />
              Woodcut, 2012
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/worksonpaper/bornutti_skizze4.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Burnutti Entwurf</i><br />
              A4, pencil on paper, 2014
            </p>
          </div>
        </div>
        <!-- end row 1 -->
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/worksonpaper/caroo.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Dichtung 1</i><br />
              A4, pencil on paper
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/worksonpaper/debt.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>NYC Debt</i><br />
              Woodcut
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/worksonpaper/eminemborner.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Eminem und Borner in Paris</i><br />
              A4, pencil on paper
            </p>
          </div>
        </div>
        <!-- end row 2 -->
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/worksonpaper/godard.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Godard</i><br />
              Woodcut
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/worksonpaper/landschaft.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Landschaft Akt</i><br />
              A4, pencil on paper
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/worksonpaper/montreal3.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Montreal Coffee</i><br />
              A4, pencil on paper
            </p>
          </div>
        </div>
        <!-- end row 3 -->
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/worksonpaper/nele.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Nele</i><br />
              A4, ink on paper
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/worksonpaper/plomo.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Platta o Plomo</i><br />
              120 x 100 cm, pencil on paper
            </p>
          </div>
        </div>
        <div class="card border-0 p-4">
          <img
            v-img
            class="card-img-top rounded-0 "
            src="@/assets/images/worksonpaper/wood3.jpg"
            alt="Card image cap"
          />
          <div class="card-body">
            <p class="card-text small text-right">
              <i>Partners of Crime</i><br />
              A3, woodcut
            </p>
          </div>
        </div>
        <!-- end row 4 -->
      </div>
      <!-- -->
    </div>

    <!--container end div-->
    <back-to-top bottom="20px" right="20px">
      <button type="button" class="btn btn-light btn-to-top">
        <i class="fa fa-chevron-up"></i>
      </button>
    </back-to-top>
  </div>
</template>

<script>
import navigation from "@/components/navigation.vue";

export default {
  components: {
    navigation,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss">
@import "./../sass/_main.scss";
</style>
